import * as React from 'react';

import { DatePicker } from '@fluentui/react';

export interface ClaimsDayRangeSelectorProps {
  disabled?: boolean;
  claimsFromDate?: string;
  claimsToDate?: string;
  actions?: {
    setClaimsFromDate: (date: string) => void;
    setClaimsToDate: (date: string) => void;
  };
}

export class ClaimsDayRangeSelector extends React.Component<ClaimsDayRangeSelectorProps> {
  public render(): JSX.Element {
    return (
      <>
        <div style={{ marginRight: 10 }}>
          <DatePicker
            onSelectDate={this.onSelectFromDate}
            label="From: MM/DD/YY"
            value={this.props.claimsFromDate ? new Date(this.props.claimsFromDate) : undefined}
            isRequired={true}
            allowTextInput={true}
            disableAutoFocus={true}
            formatDate={this.onFormatDate}
          />
        </div>
        <div style={{ marginRight: 10 }}>
          <DatePicker
            onSelectDate={this.onSelectToDate}
            label="To: MM/DD/YY"
            value={this.props.claimsToDate ? new Date(this.props.claimsToDate) : undefined}
            isRequired={true}
            allowTextInput={true}
            disableAutoFocus={true}
            formatDate={this.onFormatDate}
          />
        </div>
      </>
    );
  }

  private onSelectFromDate = (date: any) => {
    if (date instanceof Date) {
      this.props.actions!.setClaimsFromDate(date.toDateString());
    }
  };
  private onSelectToDate = (date: any) => {
    if (date instanceof Date) {
      this.props.actions!.setClaimsToDate(date.toDateString());
    }
  };

  private onFormatDate = (date?: Date): string => {
    return date ? date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() : '';
  };
}
